<template>
  <ComponentsLayoutWithNavbar
    id="bids-history"
    main_color="var(--color-main-green)">
    <template #breadcrumbs>
      <TenderBreadcrumbs
        :current="$t('Tenders.History')"
        :loading="loading"/>
    </template>
    <template #main_content>
      <template v-if="loading">
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-10 pr-8"
          :tile="true"
          type="heading"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-3 pr-8"
          :tile="true"
          type="sentences"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-4 main__green mt-5"
          :tile="true"
          type=" table-thead, table-tbody"
          width="100%"/>
      </template>
      <v-card
        v-else
        class="width-100 px-0 main__green pt-3"
        elevation="0">
        <v-card-title class="pa-0 pb-4 h1-headline">
          #{{ tender ? tender.tenderNumber : '–' }}
        </v-card-title>
        <v-card-subtitle class="px-0 py-2 text-start h6-text black--text">
          {{ tender ? tender.title : '–' }}
        </v-card-subtitle>
        <v-card-subtitle class="pa-0 text-start h8-text ">
          {{ tender && tender.category ? `${tender.category.code} ${tender.category.title}` : '–' }}
        </v-card-subtitle>
        <v-card-text class="pa-0 pr-2">
          <v-tabs
            v-model="tab"
            background-color="var(--color-main-green)"
            class="bids-history-tabs tabs pb-5 mt-5"
            color="var(--black-color)">
            <v-tab
              v-for="(tabItem, n) in tabs"
              :key="tabItem.name"
              class="px-0 h7-text black--text tab-name text-uppercase "
              :class="{'mr-5': n != tabs.length - 1}">
              {{ tabItem.name }}
            </v-tab>
            <sButton
              class="px-2 py-1 ml-auto"
              data-qa="btn-export-to-excel"
              icon="excel"
              type="text"
              @click="exportHstory">
              {{ $t('Tenders.UploadToExcel') }}
            </sButton>
          </v-tabs>
          <v-tabs-items
            v-if="tabs"
            ref="tabs"
            v-model="tab"
            class="main__green">
            <div class="h7-text  black--text ">
              {{ tabs[tab].info }}
            </div>
            <v-tab-item :class=" tabs[0].value ">
              <v-row no-gutters>
                <sIcon
                  v-if="load_items"
                  class="align-self-center my-3"
                  color="var(--white-color)"
                  size="30"
                  spin
                  type="loading"/>
                <v-col
                  v-else-if="tabs[0].items.length"
                  data-qa="bid-history-participants">
                  <BidHistoryLotCard
                    v-for="(item, n) in tabs[0].items"
                    :key="n"
                    class="mb-5"
                    :lot="item"
                    :tender="tender"/>
                </v-col>
                <EmptyBlock
                  v-else
                  custom-class="mt-0 pa-10"
                  data-qa="bid-history-participant-noData"
                  :text="$t('Tenders.NoData')"/>
              </v-row>
            </v-tab-item>
            <v-tab-item :class=" tabs[1].value ">
              <v-row no-gutters>
                <sIcon
                  v-if="load_items"
                  class="align-self-center my-3"
                  color="var(--white-color)"
                  size="30"
                  spin
                  type="loading"/>
                <v-col
                  v-else-if="tabs[1].items.length"
                  data-qa="bid-history-participants">
                  <BidHistoryParticipantCard
                    v-for="(item, n) in tabs[1].items"
                    :key="n"
                    class="mb-5"
                    :participant="item"
                    :tender="tender"/>
                </v-col>
                <EmptyBlock
                  v-else
                  custom-class="mt-0 pa-10"
                  data-qa="bid-history-participant-noData"
                  :text="$t('Tenders.NoData')"/>
              </v-row>
            </v-tab-item>
            <v-tab-item
              v-if=" tabs[2]"
              :class=" tabs[2].value">
              <sIcon
                v-if="load_items"
                class="align-self-center my-3"
                color="var(--white-color)"
                size="30"
                spin
                type="loading"/>
              <BidHistoryPrequalification
                v-else-if="tabs[2].items.length"
                data-qa="bid-history-prequalification"
                :items="tabs[2].items"
                :tender="tender"/>
              <EmptyBlock
                v-else
                custom-class="mt-0 pa-10"
                data-qa="bid-history-prequalification-noData"
                :text="$t('Tenders.NoData')"/>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </template>
    <template #nav_bar="{ mini }">
      <v-container
        v-show="!mini"
        class="tender-info pa-0  main__light_green">
        <template v-if="loading">
          <v-skeleton-loader
            class="mt-10 px-8"
            height="50px"
            type="heading"
            width="80%"/>
          <v-skeleton-loader
            v-for="(i, n) in new Array(3)"
            :key="n"
            class="mt-3 px-8"
            height="50px"
            type="sentences"
            width="100%"/>
        </template>
        <template v-else>
          <InfoBar
            ref="info"
            class="pl-2 secondary__green_chosen"
            short
            :tender="tender"/>
          <BackToTenderBtn
            :tender-id="tender.tenderId"/>
        </template>
      </v-container>
    </template>
  </ComponentsLayoutWithNavbar>
</template>
<script>
import InfoBar from 'components/tenders/tender page/InfoBar.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import BackToTenderBtn from 'components/tenders/BackToTenderBtn.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'
import BidHistoryLotCard from 'components/tenders/tender page/bids history/BidHistoryLotCard.vue'
import BidHistoryParticipantCard from 'components/tenders/tender page/bids history/BidHistoryParticipantCard.vue'
import BidHistoryPrequalification from 'components/tenders/tender page/bids history/BidHistoryPrequalification.vue'

import { BidsHistoryReportFile } from '@/types/commonFile.js'
import { mapGetters } from 'vuex'

export default {
  name: 'bidsHistory',
  data() {
    return {
      info: [],
      tender: {},
      loading: true,
      load_items: false,
      tab: null,
      tabs: []
    }
  },
  async created() {
    this.tabs = [
      {
        name: this.$t('Tenders.Lots'),
        value: 'historyLots',
        items: []
      },
      {
        name: this.$t('Tenders.Suppliers'),
        value: 'historyBidders',
        items: []
      },
    ]
    this.tab = 0
    await this.getItem()
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
    }),
  },
  methods: {
    async getItem(condition) {
      this.loading = true
      await this.$store.dispatch('getTenderItem', {id: Number(this.$route.params.tenderId), condition: condition})
        .then (async res => {
          if (!res || [this.statuseKeys.SUBMISSION, this.statuseKeys.AUCTION].includes(res?.tenderStatus?.id) && this.settings.tenderSettings.hideProposalsUntilRemoveTenderFromSite) {
            this.$router.replace({ name: 'tenderitem', params: { id: +this.$route.params.tenderId, org: +this.$route.params.org } })
            return
          }

          this.tender = res
          let bid_type = this.tender.biddingType
          let status = this.tender.tenderStatus?.id
          let items =  this.tabs[0]?.items?.length 
            ? this.tabs[0]?.items
            : await this.$store.dispatch(this.tabs[0].value, Number(this.$route.params.tenderId) )

          if ((bid_type?.isMultistage || bid_type.isFrameFirstStage) && status != 1 && status != 4 && items?.length) {
            this.tabs.push(
              {
                name: this.$t('Tenders.Retraining'),
                value: 'prequalification',
                items: []
              })
          }

        })
        .finally(() => this.loading = false)
    },
    exportHstory() {
      let title = `${this.$t('Tenders.BidHistory')} ${this.$t('Tenders.Tender')} #${this.tender.tenderNumber}.xlsx`,
        file = new BidsHistoryReportFile(this.$route.params.tenderId, title )
      file.saveFile()
    }
  },
  watch: {
    async tab(val) {
      if ( !this.tabs[val].items?.length ) {

        this.load_items = true
        await this.$store.dispatch(this.tabs[val].value, Number(this.$route.params.tenderId))
          .then(res => {
            if (this.tender?.lotGroups?.length && this.tabs[val].value === 'historyLots') {
              res.forEach(lot => {
                let lotGroup = this.tender.lotGroups?.find(group => group.innerLotIds?.includes(lot.lotId))
                if (lotGroup) {
                  lot.lotTitle = lotGroup?.title ? `${lotGroup.title} ${lot.lotTitle}` : lot.lotTitle
                }
              })
            }
            this.$set(this.tabs[val], 'items', res)
            this.$forceUpdate()
            this.load_items = false
          })
      }
    }
  },
  components: {
    InfoBar,
    EmptyBlock,
    BackToTenderBtn,
    TenderBreadcrumbs,
    BidHistoryLotCard,
    BidHistoryParticipantCard,
    ComponentsLayoutWithNavbar,
    BidHistoryPrequalification
  }
}
</script>
<style lang="scss" scoped>
.tab-name {
  letter-spacing: 0.05em;
}
</style>
